import React from 'react';
import { adminOrders, monthlySales } from '../adminData';

function AdminSales() {
  const maxSales = Math.max(...monthlySales.map(m => m.value));
  const totalRevenue = adminOrders.reduce((sum, o) => sum + o.total, 0);
  const avgOrder = (totalRevenue / adminOrders.length).toFixed(0);

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Sales</h1>
          <p>Track sales performance and order history.</p>
        </div>
      </div>

      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <h3>{totalRevenue.toLocaleString()} SAR</h3>
          <p>Total Revenue</p>
        </div>
        <div className="admin-stat-card">
          <h3>{adminOrders.length}</h3>
          <p>Total Orders</p>
        </div>
        <div className="admin-stat-card">
          <h3>{avgOrder} SAR</h3>
          <p>Average Order Value</p>
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <h3>Sales Trend (Last 7 Months)</h3>
        </div>
        <div className="admin-line-chart">
          <svg viewBox="0 0 700 220" className="admin-line-svg">
            <polyline
              fill="none"
              stroke="#d4af37"
              strokeWidth="3"
              points={monthlySales.map((m, i) => `${i * 110 + 20},${200 - (m.value / maxSales) * 180}`).join(' ')}
            />
            {monthlySales.map((m, i) => (
              <circle key={i} cx={i * 110 + 20} cy={200 - (m.value / maxSales) * 180} r="5" fill="#ffd700" />
            ))}
          </svg>
          <div className="admin-line-labels">
            {monthlySales.map((m, i) => (
              <span key={i}>{m.month}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <h3>All Orders</h3>
        </div>
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Items</th>
                <th>Total</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {adminOrders.map(o => (
                <tr key={o.id}>
                  <td className="admin-td-gold">#{o.id}</td>
                  <td>{o.customer}</td>
                  <td>{o.items}</td>
                  <td className="admin-td-gold">{o.total} SAR</td>
                  <td><span className={`admin-status-pill status-${o.status.toLowerCase()}`}>{o.status}</span></td>
                  <td>{o.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminSales;
